import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Checkbox = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill-rule="nonzero"
      d="M2 22V2h20v20H2Zm1-1h18V3H3v18ZM17.005 8.005l.99.99L10 16.99l-3.995-3.995.99-.99L10 15.01l7.005-7.005Z"
    />
  </SvgIcon>
);

export default Checkbox;
